import { Routes } from '@angular/router';

import { loginRedirectGuard } from '../shared/route-guards/login-redirect.guard';
import { existUserGuard } from '../shared/route-guards/exist-user.guard';
import { userProfileAtGuard } from '../shared/route-guards/user-profile-at.guard';
import { streamDetailsResolver } from '../shared/resolvers/stream-resolve.service';
import { userProfileAtMatcher } from '../shared/matchers/user-profile-at.matcher';
import { userResolver } from '../shared/resolvers/user-resolve.service';
import { accountRedirectGuard } from '../shared/route-guards/account-redirect.guard';
import { userIdentResolver } from '../shared/resolvers/user-ident-resolve.service';
import { userProfileAtResolver } from '../shared/resolvers/user-resolve-at.service';

export const userRoutes: Routes = [
    {
        path: 'user/my-notes',
        loadComponent: () => import('./my-notes/my-notes.component').then(c => c.MyNotesComponent),
        canActivate: [loginRedirectGuard]
    },
    {
        path: 'user/notifications/:id',
        loadComponent: () => import('./notifications/notifications.component').then(c => c.NotificationsComponent),
        canActivate: [loginRedirectGuard]
    },
    {
        path: 'user/notifications',
        loadComponent: () => import('./notifications/notifications.component').then(c => c.NotificationsComponent),
        canActivate: [loginRedirectGuard]
    },
    {
        path: 'user/trash',
        loadComponent: () => import('./trash/trash.component').then(c => c.TrushComponent),
        canActivate: [loginRedirectGuard]
    },
    {
        path: 'user/my-communities',
        loadComponent: () => import('./my-communities/my-communities.component').then(c => c.MyCommunitiesComponent),
        canActivate: [loginRedirectGuard]
    },
    {
        path: 'user/my-subscriptions',
        loadComponent: () => import('./my-subscriptions/my-subscriptions.component').then(c => c.MySubscriptionsComponent),
        canActivate: [loginRedirectGuard]
    },
    {
        path: 'user/followed-streams',
        loadComponent: () => import('./followed-streams/followed-streams.component').then(c => c.FollowedStreamsComponent),
        canActivate: [loginRedirectGuard]
    },
    {
        path: 'user/:userId/streams/:id/:myStreamName',
        loadComponent: () => import('./../streams/stream-details/stream-details.component').then(c => c.StreamDetailsComponent),
        resolve: {
          requestedStream: streamDetailsResolver,
          user: userResolver
        },
        canActivate: [existUserGuard]
    },
    {
        path: 'user/:userId/streams/:id',
        loadComponent: () => import('./../streams/stream-details/stream-details.component').then(c => c.StreamDetailsComponent),
        resolve: {
          requestedStream: streamDetailsResolver,
          user: userResolver
        },
        canActivate: [existUserGuard]
    },
    {
        path: 'user/:userId/saved-notes',
        loadComponent: () => import('./saved-notes/saved-notes.component').then(c => c.SavedNotesComponent),
        canActivate: [loginRedirectGuard, accountRedirectGuard]
    },
    {
        path: 'user/:userId/my-account',
        loadComponent: () => import('./user.component').then(c => c.UserComponent),
        canActivate: [loginRedirectGuard, accountRedirectGuard],
        resolve: {
          user: userResolver
        }
    },
    {
        path: 'user/:userId/earnings',
        loadComponent: () => import('./earnings/earnings.component').then(c => c.EarningsComponent),
        canActivate: [loginRedirectGuard, accountRedirectGuard]
    },
    {
        path: 'user/:userId/sales',
        loadComponent: () => import('./my-sales/my-sales.component').then(c => c.MySalesComponent),
        canActivate: [loginRedirectGuard, accountRedirectGuard]
    },
    {
      path: 'user/:userIdent/profile',
      loadComponent: () => import('./public-profile/public-profile.component').then(c => c.PublicProfileComponent),
      resolve: {
        user: userResolver
      },
      canActivate: [existUserGuard],
      children: [
        {
          path: 'notes',
          loadComponent: () => import('./public-profile/public-profile.component').then(c => c.PublicProfileComponent),
          data: {
            mode: 'notes',
            renderMode: 'dynamic'
          }
        },
        {
          path: 'streams',
          loadComponent: () => import('./public-profile/public-profile.component').then(c => c.PublicProfileComponent),
          data: {
            mode: 'streams'
          }
        },
        {
          path: 'comments',
          loadComponent: () => import('./public-profile/public-profile.component').then(c => c.PublicProfileComponent),
          data: {
            mode: 'comments',
            renderMode: 'dynamic'
          }
        },
        {
          path: 'ratings',
          loadComponent: () => import('./public-profile/public-profile.component').then(c => c.PublicProfileComponent),
          data: {
            mode: 'ratings'
          }
        },
        {
          path: 'delete/:token',
          loadComponent: () => import('./../profile-delete/profile-delete.component').then(c => c.ProfileDeleteComponent),
          data: {
            renderMode: 'dynamic'
          }
        },
        {
          path: '**',
          redirectTo: 'notes'
        }
      ]
    },
    {
      matcher: userProfileAtMatcher,
      loadComponent: () => import('../profile-view/profile-view.component').then(c => c.ProfileViewComponent),
      canActivate: [userProfileAtGuard],
      resolve: {
        user: userResolver,
        userAt: userProfileAtResolver
      }
    },
    {
      path: 'u',
      children: [
        {
          path: ':userIdOrName',
          loadComponent: () => import('../profile-view/profile-view.component').then(c => c.ProfileViewComponent),
          canActivate: [existUserGuard],
          resolve: {
            user: userResolver,
            userAt: userIdentResolver
          }
        }
      ]
    }
];